export default __webpack_public_path__ + "static/svg-sprite-60cc64e11e9b3f6a39503880edb6076b.svg";